import { render, staticRenderFns } from "./Crash.vue?vue&type=template&id=53c65c75&scoped=true"
import script from "./Crash.vue?vue&type=script&lang=js"
export * from "./Crash.vue?vue&type=script&lang=js"
import style0 from "./Crash.vue?vue&type=style&index=0&id=53c65c75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c65c75",
  null
  
)

export default component.exports